<script>
	const staffRes = {
		title: '编辑分段',
		rule: {
			"width": "1000",
			"height": "800",
			"fApi": [],
			"rule": [{
					"type": "el-divider",
					"children": [
						"商品信息"
					]
				},
				{
					"type": "$input",
					"field": "specCode",
					"title": "商品编码",
					"value": null,
					"hidden": false,
					"props": {
						"disabled": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "goodsName",
					"title": "商品名称",
					"value": null,
					"hidden": false,
					"props": {
						"disabled": true,
						"showPassword": false,
						"placeholder": ""
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "goodsCode",
					"title": "分类",
					"value": null,
					"hidden": false,
					"props": {
						"disabled": true,
						"showPassword": false,
						"placeholder": ""
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "password",
					"title": "子商品",
					"value": null,
					"hidden": false,
					"props": {
						"disabled": true,
						"showPassword": false,
						"placeholder": ""
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "keywords",
					"title": "关键字",
					"value": null,
					"hidden": false,
					"props": {
						"collapseTags": false,
						"allowCreate": true,
						"multiple": true,
						"placeholder": ""
					},
					"col": {
						"span": 20,
						"offset": 0
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$upload",
					"field": "specPic",
					"title": "图片",
					"value": null,
					"hidden": false,
					"props": {
						"disabled": true,
						"limit": 1,
						"showPassword": false,
						"placeholder": ""
					},
					"col": {
						"span": 24,
						"offset": 0
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"文档"
					]
				},
				{
					"type": "$table",
					"field": "$son_detail",
					"tablename": "文档",
					"config": {
						"blank": true,
						"checkbox": false
					},
					"title": "",
					"value": "",
					"hidden": false,
					"props": {
						"mainModuleName": "",
						"mainid": 0,
						"boxindex": 0,
						"moduleName": "",
						"height": 500,
						"size": "mini",
						"fields": [{
								"virtual": false,
								"type": "$select",
								"field": "name",
								"title": "文件名称",
								"order": 0,
								"value": "",
								"props": {
									"optionsFromRow": true
								},
								"options": [],
								"info": [],
								"col": [],
								"style": [],
								"width": 100,
								"fixed": false,
								"penetrate": false,
								"hidden": false,
								"children": [],
								"validate": [{
									"required": true,
									"message": "必填项"
								}]
							},
							{
								"virtual": false,
								"type": "$upload",
								"field": "url",
								"title": "文件",
								"order": 0,
								"value": [],
								"props": {
									"moduleName": "goodsworkflow"
								},
								"options": [],
								"info": [],
								"col": {
									"span": 24,
									"offset": 0
								},
								"style": [],
								"width": 100,
								"fixed": false,
								"penetrate": false,
								"hidden": false,
								"children": [],
								"validate": [{
									"required": true,
									"message": "必填项"
								}]
							},
							{
								"virtual": false,
								"type": "$input",
								"field": "mark",
								"title": "备注",
								"order": 0,
								"value": "",
								"props": [],
								"options": [],
								"info": [],
								"col": [],
								"style": [],
								"width": 100,
								"fixed": false,
								"penetrate": false,
								"hidden": false,
								"children": [],
								"validate": [{
									"required": false,
									"message": "必填项"
								}]
							}
						],
						"pagerConfig": {
							"currentPage": 1,
							"pageSize": 20,
							"total": 0,
							"enabled": false
						},
						"formConfig": null,
						"buttons": [{
								"code": "hidden",
								"name": "隐藏",
								"disabled": false
							},
							{
								"code": "add",
								"name": "新增",
								"disabled": true
							},
							{
								"code": "del",
								"name": "删除",
								"disabled": true,
								"type": "operate"
							}
						]
					},
					"col": {
						"span": 24
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 10,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}

	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'staffForm',
		props: {
			type: {
				default: () => {
					return '产品文档库'
				}
			},
			segment: {
				default: () => {
					return null
				}
			},

		},
		data() {
			return {
				sourcedata: null,
				filenameoption: []
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next) {
				let options = []
				let getEmun = window.systemMethods.getEmun('goodsfile')
				getEmun.forEach((item) => {
					options.push({
						value: item.label,
						label: item.label
					})
				})
				this.filenameoption = options
				next()
			},
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					let res = JSON.parse(JSON.stringify(staffRes))
					this.rule = res.rule
					if (this.controlltype == 2) {
						this.rule.rule.forEach((item) => {
							if (item.field == 'account') {
								item.props.disabled = true
							}
							if (item.field == 'password') {
								item.hidden = true
							}
						})
					}
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height

					this.openwindow()
				})
			},
			get() {
				return new Promise((resolve) => {
					this.$api.knowledge.get(this.id).then((res) => {
						this.sourcedata = res
						resolve()
					}, () => {
						resolve()
					})

				})
			},
			update(formData) {
				let detail = this.fApi.el('$son_detail').getTableData().fullData
				let data = {
					attr: {
						specPic: formData.specPic[0].path,
						specCode: formData.specCode,
						goodsCode: formData.goodsCode,
						goodsName: formData.goodsName,
					},
					url: {
						url: detail[0].url.map((item) => {
							return item.path
						}),
						name: detail[0].name
					},
					
				}
				if(formData.keywords){
					data.keywords = formData.keywords
				}
				this.$api.knowledge.update(this.id, {
					data: data,
					segment:this.segment
				}).then(() => {

				})
				console.log(data)
			},
			regestEvent(rule, fApi) {
				//console.log(fApi, this.sourcedata, 1111)
				fApi.setValue('specCode', this.sourcedata.attr.specCode)
				fApi.setValue('goodsCode', this.sourcedata.attr.goodsCode)
				fApi.setValue('goodsName', this.sourcedata.attr.goodsName)
				fApi.setValue('keywords', this.sourcedata.keywords)
				fApi.setValue('specPic', [this.encodeFile(this.sourcedata.attr.specPic)])
				let detailtable = fApi.el('$son_detail')
				detailtable.list = () => {
					return new Promise((reslove) => {
						let detail = JSON.parse(JSON.stringify(this.sourcedata.url))
						detail.id = Math.random()
						detail.selectoption = this.filenameoption
						detail.mark = 123
						detail.url = detail.url.map((item) => {
							return this.encodeFile(item)
						})
						reslove({
							list: [detail]
						})
					})
				}
			},
			encodeFile(url) {
				let suffix = url.split('.')
				suffix = suffix[suffix.length - 1]
				return {
					uid: Math.random(),
					url: url,
					name: '文件.' + suffix,
					path: url,
					status: 'success'
				}
			},
			tableAdd(e) {
				if (this.type == '产品文档库') {
					e.obj.selectoption = this.filenameoption
				}
				e.next()
			}
		},
		components: {

		}
	}
</script>